<template>
	<div>
		<div
			v-for="item in facts"
			:key="item.id"
			class="r2 p2 mb2 cu2 bg5"
			:class="[{ 'bc2 b2': item.isSelected }, { 'bc7 b1': !item.isSelected }]"
			@click="onClickSection($event, item)"
		>
			<!-- type and dataType -->
			<div class="lh125 c6 fw7 fs3">
				{{ item.type ? item.type : "N/A" }}
				<em>({{ item.dataType }})</em>
			</div>

			<!-- Value -->
			<!-- Edit fact -->
			<div v-if="updatingItemId === item.id">
				<entity-fact-update
					:entityId="entityId"
					:value="item"
					:isLoading="isLoading"
					@fact:update="onUpdateFact"
				/>
			</div>

			<div v-else>
				<!-- objectValue -->
				<div v-if="item.dataType === 'object'" class="mt1">
					<div v-for="obj in item.value" :key="obj.key" class="xs-12 lh125 mb1">
						{{ obj.key }}:
						<div v-if="obj.value.objectValue">
							<div
								class="ml2"
								v-for="obj1 in obj.value.objectValue"
								:key="obj1.key"
							>
								{{ obj1.key }}:
								<span class="fw7">
									{{ obj1.value | extractFromScalarValueFilter | valueFilter }}
								</span>
							</div>
						</div>
						<span v-else class="fw7">
							{{ obj.value | extractFromScalarValueFilter | valueFilter }}
						</span>
					</div>
				</div>

				<!-- Simple - stringValue, dateValue, numberValue, booleanValue -->
				<div class="lh125" v-else>
					{{ item.value | valueFilter }}
				</div>
			</div>

			<div
				v-if="updatingItemId !== item.id"
				class="xs-12 mt1 flex xs-between xs-middle"
			>
				<!-- Suggested tag -->
				<div class="xs-6">
					<j-tag
						v-if="item.isSuggested"
						size="small"
						variant="warning"
						label="Suggested"
					/>
				</div>
				<!-- Edit btn -->
				<!-- data-to-ignore is used on the container click handler, to detect if the click is on this button and discard the event -->
				<div>
					<j-button
						:data-to-ignore="true"
						type="tertiary"
						@click="setUpdateItem(item)"
						size="xsmall"
						:isDisabled="isLoading"
						>{{ $t("edit") }}</j-button
					>
					<j-button
						class="ml2"
						:data-to-ignore="true"
						type="error2"
						@click="onRemoveFact(item.id)"
						size="xsmall"
						:isDisabled="isLoading"
						>{{ $t("remove") }}</j-button
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import JTag from "@/components/JTag"
import JButton from "@/components/JButton"
import EntityFactUpdate from "./EntityFactUpdate"
import { valueFilter, extractFromScalarValueFilter } from "./utils"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { JTag, JButton, EntityFactUpdate },

	data() {
		return {
			isLoading: false,
			isExpended: false,
			updatingItemId: null
		}
	},

	props: {
		entityId: String,
		facts: {
			type: Array,
			default: () => []
		}
	},

	computed: {
		computedSuggested() {
			return this.facts.filter(fact => fact.isSuggested)
		},
		computedOtherFacts() {
			return this.facts.filter(fact => !fact.isSuggested)
		}
	},

	methods: {
		onClickSection(event, item) {
			// If is updating the item, then clicking on it is discarded
			if (this.updatingItemId === item.id) return
			// Check the to-ignore data because we don't want to emit event if the click is on the Edit button
			if (!event?.target?.dataset?.toIgnore) this.$emit("item:clicked", item)
		},

		setUpdateItem(item) {
			if (this.updatingItemId === item.id) this.updatingItemId = null
			this.updatingItemId = item.id
		},

		async onUpdateFact(payload) {
			const query = gql`
				mutation updateFact($entityId: String!, $input: updateFactInput!) {
					updateFact(entityId: $entityId, updateFactInput: $input) {
						errors
						status
						errors_2 {
							code
							message
						}
					}
				}
			`

			this.isLoading = true

			const res = await api({ query, variables: payload })

			if (res?.data?.updateFact?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.errors || ["Oops! Cannot update the fact."]
				)
				this.isLoading = false
			} else {
				this.updatingItemId = null
				// Update all entities in store by refetching the case graph
				await this.$store.dispatch("caseManagement/fetchCase", {
					caseId: this.$store.state.caseManagement.caseId
				})
				this.isLoading = false
			}
		},

		async onRemoveFact(id) {
			const query = gql`
				mutation removeFact($entityId: String!, $id: String!) {
					removeFact(entityId: $entityId, id: $id) {
						errors
						status
						errors_2 {
							code
							message
						}
					}
				}
			`
			const variables = {
				id,
				entityId: this.entityId
			}

			this.isLoading = true

			const res = await api({ query, variables })

			if (res?.data?.removeFact?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.errors || ["Oops! Cannot remove the fact."]
				)
				this.isLoading = false
			} else {
				await this.$store.dispatch("caseManagement/fetchCase", {
					caseId: this.$store.state.caseManagement.caseId
				})
				this.isLoading = false
			}
		}
	},

	filters: {
		valueFilter,
		extractFromScalarValueFilter
	}
}
</script>
